<template>
  <el-popconfirm
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot /><slot
      slot="reference"
      name="reference"
    />
  </el-popconfirm>
</template>

<script>
import ElPopconfirm from 'vue-xpc/src/element-ui/packages/popconfirm/src/main.vue';
export default {
  name: 'RtPopconfirm',
  components: {
    ElPopconfirm
  }
}
</script>



// WEBPACK FOOTER //
// rtPopconfirm.vue?300d463e